/**
 * Dataverse pay-metrics keys (v1/pay-metrics), grouped by bucket. Centralized so a backend
 * rename is a one-line change, and a typo can't silently surface as "no data" in a card.
 */
export const METRIC_KEYS = {
    serve: {
        ERP: "ERP",
        EXPERT_5STAR: "Expert 5Star",
        CRT: "CRT",
    },
    solve: {
        TRANSFER_RATE: "Transfer Rate",
        OCR: "OCR",
    },
    sell: {
        NET_ENROLLS: "Net Enrolls",
    },
} as const;
